import BarcodeReaderContentStrich from './BarcodeReaderContent.strich';
import BarcodeReaderContentZXing from './BarcodeReaderContent.zxing';

const BarcodeReaderContent = import.meta.env.VITE_STRICH_LICENCE_KEY
  ? BarcodeReaderContentStrich
  : BarcodeReaderContentZXing;

export default BarcodeReaderContent;
